
import Paginator from "../shared/TablePaginator";
import { usePaginator } from "../../../utils/hooks/paginator.hooks";
import { useAppSelector } from "@hypexone/uicore";

const rowsPerPage = 25;

interface TableComponentProp {
  columns: any,
  filters: any,
  setFilters: any,
  records: any,
  reports: String,
  pageToken: any
}

const TableComponent: React.FC<TableComponentProp> = (props) => {
  const { columns, records, filters, setFilters, pageToken, reports } = props;
  const { currentPage, paginatedData, totalPages, handlePageChange } =
    usePaginator(records, rowsPerPage);
  const { langData } = useAppSelector((state) => state.cms);
  const renderAmount = (amount: number) => {
   return <div className={`${amount>0?'text-green-600':'text-red-500'}`}>{amount}</div>
  };

  return (
    <div className="flex flex-col items-center">
      <div className="overflow-x-auto  w-full text-[12px]">
        <table className="min-w-full border-separate border-spacing-0">
          <thead>
            <tr>
              {columns?.map((column: any, index: number) => (
                <th
                  key={index}
                  className="border bg-black text-white lg:text-black lg:bg-white border-gray-300 p-1"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {paginatedData.length > 0 ? (
              paginatedData.map((row, rowIndex) => {
                // Get the betType from the row to apply conditional background color
                const rowBackgroundColor =
                  row.betType === "BACK"
                    ? "bg-blue13" // Blue for BACK
                    : row.betType === "LAY"
                      ? "bg-pink1" // Pink for LAY
                      : ""; // Default background for others

                return (
                  <tr key={rowIndex} className={`${rowBackgroundColor}`}>
                    {Object.keys(row).map((key, colIndex) => {
                      return (
                        <td key={colIndex} className="border border-gray-300 p-2">
                          {row[key] !== null ? key=="credit_debit"?renderAmount(row[key]):row[key]:"-"}
                        </td>
                      );
                    })}

                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="bg-[#F2F2F2] p-2">
                  {langData?.['no_data_to_display']}
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={columns.length + 1} className="p-2 text-right">
                <Paginator
                  setFilters={setFilters}
                  filters={filters}
                  pageToken={pageToken}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default TableComponent;
